import { defaultEngine, defaultFuel } from '@common/constants';
import { FormikConfig } from 'formik';

import { IProject } from '~/@views/UserView/ProjectPage/ProjectMassesDetails/types';
import { DeliveryLineSenderCreateInput, DeliveryLineStatus } from '~/graphql';
import i18n from '~/i18n';

import {
    DeliveryLineDumpLoad,
    getDeliveryLineValidationSchema,
    IDeliveryLineFormValues,
} from './DeliveryLineFormikCommon';

export function getDeliveryLineCreateFormikConfig(
    createDeliveryLine: (input: DeliveryLineSenderCreateInput) => Promise<unknown>,
    project: IProject,
    dumpLoad: DeliveryLineDumpLoad | null = null,
    canCreateDeliveryLine: (dumpLoad: DeliveryLineDumpLoad) => boolean
): FormikConfig<IDeliveryLineFormValues> {
    return {
        initialValues: {
            dumpLoad,
            project,
            weight: 0,
            date: new Date(),
            truckRegistrationNumber: '',
            truckCapacity: 0,
            receipt: null,
            senderComment: '',
            driverComment: '',
            vehicleType: null,
            fuel: defaultFuel,
            engine: defaultEngine,
            status: {
                value: DeliveryLineStatus.DELIVERED,
                label: i18n.DeliveryLineStatuses[DeliveryLineStatus.DELIVERED],
            },
            isVerified: false,
        },
        validationSchema: getDeliveryLineValidationSchema(canCreateDeliveryLine, undefined),
        onSubmit: async (values, { resetForm }) => {
            const {
                dumpLoad,
                weight,
                date,
                truckRegistrationNumber,
                truckCapacity,
                receipt,
                senderComment,
                driverComment,
                vehicleType,
                fuel,
                engine,
            } = values;

            if (!dumpLoad || !weight || !date || !receipt || !vehicleType || !fuel || !engine) {
                throw new Error('Internal error');
            }

            const input: DeliveryLineSenderCreateInput = {
                orderNumber: dumpLoad.serialNumber,
                weight,
                plannedStartDate: date.toISOString(),
                truckRegistrationNumber,
                truckCapacity: truckCapacity || 0,
                receipt,
                vehicleTypeId: vehicleType.id,
                fuel,
                engine,
                senderComment,
                driverComment,
            };

            await createDeliveryLine(input);
            resetForm();
        },
    };
}
